// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShrinkOutlinedSvg from "@ant-design/icons-svg/es/asn/ShrinkOutlined";
import AntdIcon from '../components/AntdIcon';

var ShrinkOutlined = function ShrinkOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShrinkOutlinedSvg
  }));
};

ShrinkOutlined.displayName = 'ShrinkOutlined';
export default React.forwardRef(ShrinkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ShrinkOutlined.js
// module id = 1799
// module chunks = 0